var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "shadow fixed z-10 w-full transition-all",
      class: {
        "backdrop-blur border-b-2 h-16 py-2": _vm.sticky,
        "h-32 py-4": !_vm.sticky
      },
      attrs: { id: "header" }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }